<template>
  <div class="header" :class="showNav ? 'active' : ''" v-on:mouseenter="mouseEnterFunc" v-on:mouseleave="mouseLeaveFunc">
    <div class="header-contain">
      <div class="logo-contain" @click="goRou('/')" >
        <div class="logo-01">
          <img src="@/assets/images/logo-01.png" />
        </div>
        <div class="logo-02">
          <img src="@/assets/images/logo-02.png" />
        </div>
      </div>
      <div class="nav-row-contain" v-if="!showNavBtn">
        <!-- <div @click="goRou('/')" class="nav-item" :class="nowNav == 'index' ? 'active' : ''">
          <div class="nav-cn">首页</div>
          <div @click="goRou('/')" class="nav-en">index</div>
        </div> -->
        <div @click="goRou('/works')" class="nav-item" :class="nowNav == 'works' ? 'active' : ''">
          <div class="nav-cn">案例</div>
          <div class="nav-en">WORK</div>
        </div>
        <div @click="goRou('/flow')" class="nav-item" :class="nowNav == 'flow' ? 'active' : ''">
          <div class="nav-cn">流程</div>
          <div class="nav-en">TIME AXIS</div>
        </div>
        <div @click="goRou('/news')" class="nav-item" :class="nowNav == 'news' ? 'active' : ''">
          <div class="nav-cn">新闻</div>
          <div class="nav-en">NEWS</div>
        </div>
        <div @click="goRou('/about')" class="nav-item" :class="nowNav == 'about' ? 'active' : ''">
          <div class="nav-cn">我们</div>
          <div class="nav-en">ABOUT US</div>
        </div>
      </div>
      <div class="nav-btn" @click="showNav = !showNav"  v-if="showNavBtn">
        <div class="nav-btn-top" :class="showNav ? 'active' : ''">
          <div class="line"></div>
        </div>
        <div class="nav-btn-bottom" :class="showNav ? 'active' : ''">
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="nav-contain">
      <div @click="goRou('/')" class="nav-item" :class="showNav ? 'active' : ''" style="transition-delay: .1s;">index</div>
      <div @click="goRou('/flow')" class="nav-item" :class="showNav ? 'active' : ''" style="transition-delay: .2s;">flow</div>
      <div @click="goRou('/works')" class="nav-item" :class="showNav ? 'active' : ''" style="transition-delay: .3s;">works</div>
      <div @click="goRou('/news')" class="nav-item" :class="showNav ? 'active' : ''" style="transition-delay: .4s;">news</div>
      <div @click="goRou('/about')" class="nav-item" :class="showNav ? 'active' : ''" style="transition-delay: .5s;">about</div>
    </div>
  </div>
  
</template>

<script>

export default {
    name: "newHeader",
    props: {
      nowNav: {
        type: String,
        default: 'index'
      }
    },
    data() {
        return {
            routeType: '',
            headerName: {
                index: 0,
                flow: 0,
                works: 0,
                news: 0,
                about: 0,
            },
            showNav: false,
            showNavBtn: false,
            navOver: false,
        }
    },
    mounted() {
      window.addEventListener('resize', this.handleResize);
      
    },
    methods: {
        goRou(path) {
            this.$router.push(path)
            this.showNav = false
        },
        handleResize() {
          // 更新 windowWidth 和 windowHeight 的值
          console.log(window.innerWidth)
        },
        mouseEnterFunc() {
          this.navOver = true
        },
        mouseLeaveFunc() {
          this.navOver = false
        }
    },
    beforeDestroy() {
      // 移除 resize 事件监听器
      window.removeEventListener('resize', this.handleResize);
    },
};
</script>
<style>
  /* 进入动画：从上到下滑入 */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-100%); /* 初始位置：上方完全不可见 */
  }
  to {
    opacity: 1;
    transform: translateY(0); /* 最终位置：正常顶部位置 */
  }
}

/* 退出动画：从下到上滑出 */
@keyframes slideUp {
  from {
    opacity: 1;
    transform: translateY(0); /* 初始位置：正常顶部位置 */
  }
  to {
    opacity: 0;
    transform: translateY(-100%); /* 最终位置：上方完全不可见 */
  }
}

/* 动画类：控制动画执行 */
.slide-down-enter {
  animation: slideDown 0.3s ease-out forwards;
}

.slide-up-leave {
  animation: slideUp 0.3s ease-in forwards;
  pointer-events: none; /* 动画期间禁止交互 */
}
</style>
<style lang="scss" scoped>
.header {
  position:fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 120px;
  z-index: 999;
  transition: all .7s ease-in-out;
  overflow: hidden;
  display: flex;
  align-items: center;
  .header-contain {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #FFFFFF;
    
    .logo-contain {
      margin-left: 5%;
      // margin-top: 47px;
      font-size: 0;
      display: flex;
      align-items: center;
      width: 30%;
      .logo-01 {
        max-width: 73px;
        max-height: 37px;
        position: relative;
        width: 17.3%;
        height: 0;
        padding-bottom: 8.7%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      .logo-02 {
        margin-left: 30px;
        max-width: 181px;
        max-height: 37px;
        position: relative;
        width: 43%;
        height: 0;
        padding-bottom: 8.7%;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .nav-btn {
      width: 130px;
      height: 100px;
      overflow: hidden;
      margin-right: 20px;
      position: relative;
      .nav-btn-top {
        padding-top: 40px;
        position: absolute;
        top: 0;
        left: 0;
        width: 130px;
        height: 100px;
        transition: all .2s ease-in-out;
        transform: rotate(0deg) translateY(0px);
      }
      .nav-btn-top.active {
        transform: rotate(30deg) translateY(6px);
      }
      .nav-btn-bottom {
        padding-top: 55px;
        position: absolute;
        top: 0;
        left: 0;
        width: 130px;
        height: 100px;
        transition: all .2s ease-in-out;
        transform: rotate(0deg) translateY(0px);
      }
      .nav-btn-bottom.active {
        transform: rotate(-30deg) translateY(-6px);
      }
      .line {
        width: 70px;
        height: 1px;
        background-color: #333333;
        margin: auto;
      }
    }
  }
  .nav-contain {
    flex: 1;
    max-width: 50%;
    display: flex;
    justify-content: space-between;
    margin: auto;
    flex-wrap: wrap;
    .nav-item {
      font-family: siyuanheiti;
      opacity: 0;
      transform: translateY(-6px);
      transition: all .2s ease-in;
      width: 120px;
      text-align: center;
      height: 60px;
      line-height: 60px;
      visibility: hidden;
      cursor: pointer;
    }
    * {
      font-family: siyuanheiti;
    }
    .nav-item.active {
      opacity: 1;
      transform: translateY(0px);
      visibility: visible;
    }
  }
}
.header.active {
  height: 100vh;
  transition: all .2s ease-in-out;
}

.nav-row-contain {
  display: flex;
  margin-right: 5%;
  // margin-top: 47px;
  height: 56px;
  width: 50%;
  min-width: 400px;
  justify-content: flex-end;
  .nav-item {
    height: 56px;
    line-height: 56px;
    font-family: siyuanheiti;
    font-size: 20px;
    width: 100px;
    margin-left: 5%;
    text-align: center;
    position: relative;
    cursor: pointer;
    .nav-en {
      font-family: siyuanheiti;
      opacity: 1;
      transform: translateY(0%);
      transition: all .3s;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    .nav-cn {
      font-family: siyuanheiti;
      opacity: 0;
      transform: translateY(100%);
      transition: all .3s;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
    
  }
  .nav-item:hover .nav-en,.nav-item.active .nav-en  {
    opacity: 0;
    transform: translateY(-100%);
  }
  .nav-item:hover .nav-cn,.nav-item.active .nav-cn  {
    opacity: 1;
    transform: translateY(0%);
  }
}
@media screen and (min-width: 680px) and (max-width: 1000px) {
  .header {
    height: 80px;
    .header-contain {
      height: 80px;
      
    }
  }
}
@media screen and (max-width: 680px) {
  .header {
    height: 60px;
    .header-contain {
      height: 60px;
      
    }
  }
  .nav-row-contain {
    display: flex;
    margin-right: 5%;
    // margin-top: 47px;
    height: 56px;
    width: 50%;
    min-width: 0;
    justify-content: flex-end;
    .nav-item {
      height: 56px;
      line-height: 56px;
      font-family: siyuanheiti;
      font-size: 10px;
      width: 50px;
      margin-left: 0px;
      text-align: center;
      position: relative;
      cursor: pointer;
      .nav-en {
        font-family: siyuanheiti;
        opacity: 1;
        transform: translateY(0%);
        transition: all .3s;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      .nav-cn {
        font-family: siyuanheiti;
        opacity: 0;
        transform: translateY(100%);
        transition: all .3s;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }
      
    }
    .nav-item:hover .nav-en,.nav-item.active .nav-en  {
      opacity: 0;
      transform: translateY(-100%);
    }
    .nav-item:hover .nav-cn,.nav-item.active .nav-cn  {
      opacity: 1;
      transform: translateY(0%);
    }
  }
}
</style>